import { DialogProps } from '@radix-ui/react-dialog';
import { Spinner } from 'components/spinner';
import dynamic from 'next/dynamic';

export type CarrelloDialogProps = DialogProps & {
  type: 'success' | 'warning' | 'question';
  title: string;
  text?: string;
  children?: React.ReactNode;
};

export const CarrelloDialog = dynamic<CarrelloDialogProps>(
  () => import('features/carrello/carrelloDialog/CarrelloDialog').then((mod) => mod.CarrelloDialog),
  {
    loading: () => <Spinner className={'sportDialog'} />,
    ssr: false,
  }
);
